import * as React from 'react';


type IProps = React.SVGProps<SVGSVGElement>;

function FatArrow(props: IProps): JSX.Element {
    return <svg
        clipRule="evenodd"
        fillRule="evenodd"
        strokeLinecap="square"
        strokeMiterlimit="1.5"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="m33 15 35.037 35.037-35.132 35.132" fill="none" strokeWidth="17" />
    </svg>;
}

export default React.memo(FatArrow);
